import { setBadgeCountAsync as expoSetBadgeCountAsync } from "expo-notifications";
import type { SetBadgeCountOptions } from "expo-notifications/build/setBadgeCountAsync";

/**
 * Web implementation for expo-notifications badge APIs
 *
 * Passes through to expo-notifications with web-specific options to use
 * the Favicon method for displaying badge counts in the browser tab.
 *
 * Note: The Redux state is still updated via setMessagesBadgeCount,
 * so UI components can display counts.
 */

export const setBadgeCountAsync = async (
  badgeCount: number,
  options?: SetBadgeCountOptions,
  // eslint-disable-next-line max-params -- matches expo-notifications API signature
): Promise<boolean> => {
  return expoSetBadgeCountAsync(badgeCount, options);
};
